import TkInfoManual from "../../components/atoms/TkInfoManual";
import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import { fakeTableList, headList, schema } from "./parts";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { Box } from "@mui/material";
import { httpAPI_APP016, httpAPI_REC010, httpAPI_REC029 } from "./api/request";
import { GlobalContext } from "../../context/globalContext";
import { useLocation, useNavigate } from "react-router-dom";
import { labelids } from "../../assets/data/TkExplanationProperty";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkBackButton from "../../components/molecules/TkBackButton";
import { BusinessContext } from "../../context/businessContext";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import {
  IAPI_APP016_Request,
  IAPI_REC010_Request,
  IAPI_REC029_Response,
} from "../../type/apiType";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import {
  CommonOrCommonRetirementFlug,
  DispDepositType,
  FormClassApply,
  formClassCorp,
  FormKbn,
  Status,
} from "../../assets/data/Constants";
import TkMemo from "../../components/molecules/TkMemo";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { ITkViewButtonJudgementStatus } from "../../type/componentsType/TkViewButtonJudgement";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import { TkGetCode } from "../../utils/TkGetCode";
import _ from "lodash";
import { isStatusAfterApproval } from "../../utils/useTools";

// 帳票情報リスト
type FormList = {
  serialNo?: number; // 連番
  facilityNo?: string; // 施設番号
  staffNo?: string; // 職員番号
  formKbn?: string; // 帳票区別
  formClass?: string; // 帳票種別
  fileName?: string; // ファイル名
  fileBase64?: string; // ファイル（base64）
};

/**
 * SCRC070105 振込先口座情報入力
 * @return SCRC070105 振込先口座情報入力
 */
const SCRC070105 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);

  const [stateTableList, setStateTableList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [responseData, setResponseData] = useState<IAPI_REC029_Response>({});
  const [isOpenDialog, setIsOpenDialog] = useState<boolean>(false);
  const [reqData, setReqData] = useState<any>();
  const [corpApplyKbn, setCorpApplyKbn] = useState<any>("1");
  const [isOpen, setIsOpen] = useState(false);
  const [bodyList, setBodyList] = useState<any>();
  const [fileList, setFileList] = useState<any>([]);
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [showSubmitButton, setShowSubmitButton] = useState(false);
  const [isWorkFlow, setIsWorkFlow] = useState(false);
  const [bankData, setBankData] = useState<any>({});

  const applyId = location.state?.applyId;
  const userType = state.authInfo?.userType;
  const isKiko = userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isKiko
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo;

  const handleInit = async () => {
    try {
      // 振込情報詳細参照
      const res = await httpAPI_REC029({
        applyId: applyId,
        contractorNo,
      });

      if (res.resultCd === "I0000") {
        let resArr = stateFakeTableList.current;

        for (let i in res) {
          let targetObj = resArr.find((item) => item.keyword === i)!;

          if (i === "depositType") {
            if (
              (res.latestApplyStatus === Status["届出待ち"] ||
                res.latestApplyStatus === Status["差戻し一時保存"]) &&
              targetObj
            ) {
              targetObj.setDefaultValue = DispDepositType["普通"];
            } else {
              res.depositType === DispDepositType["普通"] &&
                (targetObj.setDefaultValue = DispDepositType["普通"]);
            }
          } else {
            targetObj &&
              (targetObj.setDefaultValue = res[i as keyof typeof res]);
            targetObj && (targetObj.text = res[i as keyof typeof res]);
          }
        }

        // 振込先金融機関
        let financialInstitution = resArr.find(
          (item) => item.keyword === "financialInstitution"
        )!;
        let bankData = {
          bankCode: res.bankCd,
          bankName: res.bankName,
          branchCode: res.branchCd,
          branchName: res.branchName,
        };
        if (Object.values(bankData).every((i) => i)) {
          financialInstitution.setDefaultValue = bankData;
          setBankData(bankData);
        }

        // 法人口座（通帳）の写し
        let corpAccountCopyFile = resArr.find(
          (item) => item.keyword === "corpAccountCopyFile"
        )!;
        const targetFile = res.formList?.find(
          (item: any) => item.formKbn === "3" && item.formClass === "5"
        );

        if (res.latestApplyStatus === "00" || res.latestApplyStatus === "16") {
          financialInstitution.onSuccessfulWithBank = handleRegisterBank;

          targetFile &&
            (corpAccountCopyFile.setDefaultValue = [
              {
                formName: targetFile.fileName,
                fileBase64: targetFile.fileBase64,
              },
            ]);

          setIsWorkFlow(false);
          setShowSubmitButton(true);

          setState({
            ...state,
            errorMsgId: "",
          });
        } else {
          for (let i in res) {
            let targetObj = resArr.find((item) => item.keyword === i)!;
            targetObj && (targetObj.disabled = true);
          }

          let corpAccountCopyFile = resArr.find(
            (item) => item.keyword === "corpAccountCopyFile"
          )!;
          corpAccountCopyFile.disabled = true;

          let showLine = isStatusAfterApproval(res.latestApplyStatus);
          let fileList = res.formList
            ?.filter((item) => item.formClass === "EXP0402033")
            .map((item) => [
              {
                children: (
                  <TkDownloadLink
                    dataname={TkGetCode(FormClassApply, item.formClass)}
                    base64filedata={item.fileBase64 ?? ""}
                    downloadBase64
                  />
                ),
              },
              {
                children: showLine && res?.symbolNo,
              },
              {
                children: showLine && res?.decisionDate,
              },
            ]);

          setFileList(fileList);

          financialInstitution.buttonDisabled = true;
          corpAccountCopyFile.type = "downloadLink";
          corpAccountCopyFile.base64filedata = targetFile?.fileBase64;
          corpAccountCopyFile.dataname = targetFile?.fileName;

          if (isKiko) {
            setIsWorkFlow(true);
            setCorpApplyKbn(res.corpApplyKbn);

            const bodyListData = res.statusList?.map((item) => [
              { children: item.managerName },
              { children: item.process },
              { children: item.createDate, align: "center" },
              { children: item.processComment },
            ]);
            setBodyList(bodyListData ?? []);
          }
        }

        setResponseData(res);
        setStateTableList([...resArr]);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res?.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 初期表示
  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeHttpRequestDataObj = (obj: any): IAPI_REC010_Request => {
    const reqObj: IAPI_REC010_Request = {
      applyId: responseData?.applyId,
      contractorNo,
      billingBankCd: bankData?.bankCode,
      billingBankName: bankData?.bankNameKatakana,
      billingBranchCd: bankData?.branchCode,
      billingBranchName: bankData?.branchNameKatakana,
      depositKind: obj?.depositType,
      billingAccountNo: obj?.accountNo,
      billingAccountHolderKana: obj.accountHolderKana,
      screenId: "SCRC070105",
    };

    return reqObj;
  };

  const makeFormListObj = (): FormList[] => {
    let data = reqData.corpAccountCopyFile;
    let fileObj: FormList[] = [];

    if (data?.length) {
      fileObj = [
        {
          serialNo: 1,
          formKbn: FormKbn["法人書類"],
          formClass: formClassCorp["法人口座（通帳）の写し"],
          staffNo: "",
          facilityNo: "",
          fileName: data[0].formName,
          fileBase64: data[0].fileBase64,
        },
      ];
    }

    return fileObj;
  };

  const handleSubmit = async (date?: any) => {
    try {
      const res = await httpAPI_REC010({
        ...makeHttpRequestDataObj(reqData),
        receptionDate: date,
        formList: makeFormListObj(),
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        setIsOpenDialog(false);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 処理ボタンクリック
  const onCheckAndSubmit = (data: any) => {
    setReqData(data);
    setIsOpenDialog(true);
  };

  // 振込先金融機関登録
  const handleRegisterBank = (data: any) => {
    let resArr = stateFakeTableList.current;
    resArr.find((item) => item.keyword === "bankCd")!.text = data?.bankCode;
    resArr.find((item) => item.keyword === "bankName")!.text =
      data?.bankNameKatakana;
    resArr.find((item) => item.keyword === "branchCd")!.text = data?.branchCode;
    resArr.find((item) => item.keyword === "branchName")!.text =
      data?.branchNameKatakana;
    setBankData(data);
    setStateTableList([...resArr]);
  };

  const makeHttpObj = (num: any, formData?: any) => {
    const data: IAPI_APP016_Request = {};
    data.applyEvent = num;
    data.reason = memoData;
    data.applyId = responseData?.applyId!;
    data.contractorNo = contractorNo;
    if (memoCheck) {
      data.inquiryCode = "1";
    }
    if (formData?.symbolNumber !== undefined) {
      data.symbolNo =
        TkGetCode(CommonOrCommonRetirementFlug, formData.symbolNumberType) +
        "第" +
        formData.symbolNumber +
        "号";

      data.decisionDate = formData.settlementDate;
    }
    return data;
  };

  const btnEvent = async (btnName: any) => {
    const num =
      btnName === "契約者に差戻し"
        ? "5"
        : btnName === "受理"
        ? "2"
        : btnName === "承認"
        ? "3"
        : btnName === "担当者に差戻し"
        ? "8"
        : btnName === "課長代理確認"
        ? "14"
        : btnName === "上長承認"
        ? "6"
        : btnName === "郵送"
        ? "11"
        : "";

    if (num === "") {
      return;
    }

    if (num === "3") {
      setIsOpen(true);
      return;
    }
    let reqData: IAPI_APP016_Request = makeHttpObj(num);
    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleSave = async (formData: any) => {
    let reqData: IAPI_APP016_Request = makeHttpObj("3", formData);
    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    } else {
      setMemoCheck(event.target.value);
    }
  };

  return (
    <Box className="SCRC070105" data-testid="SCRC070105PageForTest">
      {isWorkFlow && (
        <TkKikoStepper
          applicationFlowType={"TYPE2"}
          businessType={"JOB-75"}
          applicationStatus={
            responseData?.latestApplyStatus as ITkViewButtonJudgementStatus
          }
          corporateApplicationClassification={corpApplyKbn}
        />
      )}
      <TkInfoManual rule={"\\n"}>
        {isKiko
          ? labelids.labelid.LBLC070105_01.replaceAll("機構へ提出する", "申請")
          : labelids.labelid.LBLC070105_01}
      </TkInfoManual>
      {isKiko && (
        <TkContractorAndNumberLine
          name="契約者(法人)名"
          no={
            businessState.common?.contractorNo +
            ":" +
            businessState.common?.contractorName
          }
        />
      )}
      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        buttonGroup={isKiko || !showSubmitButton ? null : <TkBackButton />}
        submitButtonText={isKiko ? "申請" : "機構へ提出する"}
        onCheckAndSubmit={(data: any) => onCheckAndSubmit(data)}
        showButton={showSubmitButton}
      />
      {isWorkFlow && (
        <Box>
          <TkMemo showTable={true} bodyList={bodyList} onChange={onChange} />
          {(responseData.latestApplyStatus === Status["上長承認待ち"] ||
            responseData.latestApplyStatus === Status["通知待ち"] ||
            responseData.latestApplyStatus === Status["郵送待ち"] ||
            responseData.latestApplyStatus === Status["処理完了"]) && (
            <TkTableWithNoLine headList={headList} bodyList={fileList} />
          )}
        </Box>
      )}
      {isWorkFlow && (
        <Box className="btn">
          <TkBackButton
            useBackParam
            navigateParam={{
              applyId,
            }}
          ></TkBackButton>
          <TkViewButtonJudgement
            flowType={"TYPE2"}
            Status={
              responseData?.latestApplyStatus as ITkViewButtonJudgementStatus
            }
            onClick={btnEvent}
          />
        </Box>
      )}
      {!isWorkFlow && !showSubmitButton && (
        <Box className="btn">
          <TkBackButton></TkBackButton>
        </Box>
      )}
      <TkApprovalDateSymbolNumberRegistrationDialog
        data-testid="SCRW050001PageForDialog"
        open={isOpen}
        onSuccess={handleSave}
        onClose={() => setIsOpen(false)}
      />
      {isKiko ? (
        <TkDateDialog
          open={isOpenDialog}
          onOky={handleSubmit}
          onCancel={() => setIsOpenDialog(false)}
          minDate={new Date("1900/01/01")}
          maxDate={new Date()}
          title="確認（申請）"
          contextText="　申請を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      ) : (
        <TkMessageDialog
          open={isOpenDialog}
          onOky={handleSubmit}
          onCancel={() => setIsOpenDialog(false)}
          title="確認（機構へ提出します）"
          contextText="　機構へ提出を行いますが、問題ないでしょうか。"
          okText="はい"
          cancelText="いいえ"
        />
      )}
    </Box>
  );
};

export default SCRC070105;
